import gql from 'graphql-tag'

export const GET_SP_BROKER = gql`
  query Query {
    spGetBroker
  }
`
export const GET_BROKER_NAME = gql`
query Query($data: getBrokerNameInput) {
  getBrokerName(data: $data)
}
`
